import { Injectable, Inject } from '@angular/core';
import { BP_CONFIG, BpConfig } from './bp.config';

@Injectable({
  providedIn: 'root'
})
export class BpConfigService {

  public showProjectConfigurationHeader: boolean = false;
  constructor(@Inject(BP_CONFIG) private config: BpConfig) {
    this.config = {
      ...config,
      apiUrl: config.apiUrl.replace(/\/+$/, '')
    };

          // When using BP in external applications, the header should be displayed as part of the project configuration
      if(this.config.parentApp && this.config.parentApp != 'BP') {
        this.showProjectConfigurationHeader = true;
      }

  }

  getConfig(): BpConfig {
    return this.config;
  }
}
